import React, { Component } from "react";
import { connect } from "react-redux";
import { Grid, Button, Icon, Label, Responsive } from "semantic-ui-react";
import { getRecallsPreregister, exportPreregisters, getListPreregisters, saveReminder } from "services/preregister";
import moment from "moment";
import DatePicker from "react-datepicker";
import PreregisterRow from "./PreregisterRow";
import PreregisterStats from "./PreregisterStats";
import PreregisterRecallsModal from "./PreregisterRecallsModal";

const styles = {
	icon: { color: "#fff", fontSize: "1.5em" },
	dateText: { color: "white", marginRight: 5, marginLeft: 5 },
};
const isMobile = () => {
	return window.innerWidth - Responsive.onlyMobile.maxWidth < 0;
};

class Preregister extends Component {
	constructor(props) {
		super(props);

		this.timeout = 0;
		this.folderTimeout = 0;
		this.state = {
			filters: { startDate: moment().add(-1, "days").format("YYYY-MM-DD"), endDate: moment().format("YYYY-MM-DD"), page: 1, count: 10 },
			openModalRecalls: false,
		};
	}

	componentDidMount() {
		this.props.getListPreregisters({
			startDate: this.state.filters.startDate,
			endDate: this.state.filters.endDate,
			page: this.state.filters.page,
			count: this.state.filters.count,
			type: "admin",
		});
		this.loadAll();
	}

	loadAll = () => {};

	exportToCSV = () => {
		this.props.exportPreregisters().then((res) => {
			const linkSource = `data:application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;base64,${res.payload.data.base64}`;
			const downloadLink = document.createElement("a");
			const fileName = `preregister${moment().format("DD-MM-YYYY")}.xlsx`;
			downloadLink.href = linkSource;
			downloadLink.download = fileName;
			downloadLink.click();
		});
	};

	openRecallManagement = () => {};

	render() {
		const list = this.props.list.data;
		const recalls = this.props.recalls.data;
		const { filters } = this.state;
		const getListPreregisters = this.props.getListPreregisters;
		return (
			<Grid textAlign="left" style={{ height: "100vh" }} verticalAlign="top">
				<Grid.Row>
					<Grid.Column style={{ maxWidth: 1250, padding: "50px 20px 50px 20px", margin: "auto", overflowY: "auto" }}>
						<Grid style={{ overflowY: "auto" }}>
							{this.props.stats.data && (
								<Grid.Row>
									<PreregisterStats preregisterStats={this.props.stats.data} />
								</Grid.Row>
							)}
							<Grid.Row color="teal">
								<Grid.Column
									mobile={10}
									tablet={8}
									computer={4}
									style={{
										display: "flex",
										alignItems: "center",
										justifyContent: "flex-start",
									}}
								>
									<Icon name="calendar alternate" style={styles.icon} />
									<span style={styles.dateText}>Du</span>
									<div style={{ width: 75 }}>
										<DatePicker
											selected={new Date(filters.startDate)}
											onChange={(date) => {
												getListPreregisters({ startDate: date, endDate: filters.endDate, page: 1, count: filters.count, type: "admin" });
												this.setState({ filters: { ...filters, startDate: date } });
											}}
											className="datePicker"
											shouldCloseOnSelect={true}
											onFocus={(e) => (e.target.readOnly = isMobile())}
											dateFormat={process.env.REACT_APP_DATE_DATEPICKER}
										/>
									</div>
									<span style={styles.dateText}>au</span>
									<div style={{ width: 75 }}>
										<DatePicker
											selected={new Date(filters.endDate)}
											onChange={(date) => {
												getListPreregisters({ startDate: filters.startDate, endDate: date, page: 1, count: filters.count, type: "admin" });
												this.setState({ filters: { ...filters, endDate: date } });
											}}
											className="datePicker"
											shouldCloseOnSelect={true}
											onFocus={(e) => (e.target.readOnly = isMobile())}
											dateFormat={process.env.REACT_APP_DATE_DATEPICKER}
										/>
									</div>
								</Grid.Column>
								<Grid.Column
									mobile={6}
									tablet={8}
									computer={4}
									style={{
										display: "flex",
										alignItems: "center",
										justifyContent: "center",
									}}
								>
									<Label>
										<Icon name="numbered list" /> {list?.length || 0}
									</Label>
								</Grid.Column>
								<Grid.Column
									mobile={6}
									tablet={8}
									computer={4}
									style={{
										display: "flex",
										alignItems: "center",
										justifyContent: "center",
									}}
								>
									<Button
										onClick={() => {
											this.props.getRecallsPreregister();
											this.setState({ openModalRecalls: true });
										}}
										icon
										labelPosition="left"
									>
										{" "}
										<Icon name="clock" />
										Gestion des rappels
									</Button>
									<PreregisterRecallsModal
										open={this.state.openModalRecalls}
										close={() => this.setState({ openModalRecalls: false })}
										recalls={recalls}
										saveReminder={this.props.saveReminder}
									/>
								</Grid.Column>

								<Grid.Column
									mobile={6}
									tablet={8}
									computer={4}
									style={{
										display: "flex",
										alignItems: "center",
										justifyContent: "flex-end",
									}}
								>
									<Button
										onClick={() => {
											this.exportToCSV();
										}}
										icon
										labelPosition="left"
									>
										{" "}
										<Icon name="download" />
										Exporter toutes les pré-inscriptions valides en CSV
									</Button>
								</Grid.Column>
							</Grid.Row>
							<Grid.Row style={{ height: "calc(100vh - 680px)" }}>
								<Grid style={{ maxHeight: "80vh", overflowY: "auto", marginBottom: "10px", marginRight: "0px", paddingRight: 0 }}>
									{list &&
										list.length > 0 &&
										[...list]
											.sort((a, b) => moment(b.created_at) - moment(a.created_at))
											.map((item, index) => <PreregisterRow preregister={item} index={index} />)}
								</Grid>
							</Grid.Row>
						</Grid>
					</Grid.Column>
				</Grid.Row>
			</Grid>
		);
	}
}

const mapStateToProps = (state) => {
	return {
		recalls: state.preregister.recalls,
		list: state.preregister.adminlist,
		stats: state.preregister.adminStats,
	};
};

const mapDispatchToProps = {
	getRecallsPreregister,
	exportPreregisters,
	getListPreregisters,
	saveReminder,
};

export default connect(mapStateToProps, mapDispatchToProps)(Preregister);
